import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import {
  TIndirectTaxTransactionExtendedParams,
  TIndirectTaxTransactionLineItemApi,
} from './types';

export function useIndirectTaxTransactionLineItems({
  transactionId,
  corporationId,
  extendedFields,
  refreshInterval,
}: TIndirectTaxTransactionExtendedParams) {
  const queryParams = new URLSearchParams();

  if (extendedFields) {
    queryParams.append('extend', extendedFields.join(','));
  }

  queryParams.append('corporationId', corporationId);

  const { data, error, isLoading, mutate } = useSWR<
    TIndirectTaxTransactionLineItemApi[]
  >(
    transactionId
      ? `new-sales-tax/transactions/${transactionId}/line-items?${queryParams.toString()}`
      : null,
    SWRFetcher({ method: 'GET' }, undefined),
    { refreshInterval }
  );

  return {
    data,
    error,
    mutate,
    isLoading,
  };
}
